/**
 * Vidéos « Montre-moi » (Cartou montre Oussé), produites par `npm run docs:videos` (scripts/docs/videos) et
 * servies par le site sous `/videos/` (fichiers publics : données fictives seulement). Même ordre que
 * `scripts/docs/videos/index.mjs` (vérifié par un test). Titres et résumés : `help.videos.<slug>` (fr / en) ;
 * les vidéos sont en français.
 */
export type HelpVideoSurface = 'site' | 'appli'

export interface HelpVideo {
  slug: string
  /** Écran filmé : le site (ordinateur) ou l'appli (téléphone). */
  surface: HelpVideoSurface
  /** Durée en secondes (affichée avant la lecture ; donnée par `npm run docs:videos`). */
  durationSec: number
}

export const HELP_VIDEOS: readonly HelpVideo[] = [
  { slug: 'site-retrouver', surface: 'site', durationSec: 51 },
  { slug: 'site-ranger', surface: 'site', durationSec: 52 },
  { slug: 'site-rangements', surface: 'site', durationSec: 59 },
  { slug: 'appli-ranger', surface: 'appli', durationSec: 69 },
  { slug: 'appli-retrouver', surface: 'appli', durationSec: 45 },
]

/** Chemin public d'un fichier de vidéo : le film, ses sous-titres ou son image d'aperçu. */
export function helpVideoFile(slug: string, kind: 'mp4' | 'vtt' | 'jpg'): string {
  return `/videos/${slug}.${kind}`
}
